module.exports = __webpack_public_path__ + "static/Face-Danielle.9c22bb75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Face-Danielle.jpg
// module id = 487
// module chunks = 144251824217401